import 'firebase/firestore'
import 'firebase/auth'
import {
	db
} from '../resources/firebase'

/**
 * Get feedback submitted by a user and save them to vuex store
 * @param {Object} store Vuex store
 */
export function getFeedback(store) {
	db.collection("feedback").doc(store.state.user.authUser.uid)
		.get()
		.then((doc) => {
			if (doc.exists) {
				store.commit('setFeedback', doc.data().feedback)
			}
		})
		.catch((error) => {
			// console.log(error)
			throw new Error(error)
		})
}



// WEBPACK FOOTER //
// ./src/api/feedback.js